var samsung_MF59_00242C = {
    name: "MF59_00242C",
    defaultCommandIndex: 1,
    commands: [
        {
            function: "KEY_POWER",
            name: "KEY_POWER",
            icon: "KEY_POWER",
            command: [68,0,4,115,2,245,1,115,2,85,6,110,35,63,17,127,2,218,154,63,234,170,183,246,170,162],
        },
        {
            function: "KEY_1",
            name: "KEY_1",
            icon: "KEY_1",
            command: [68,0,4,115,2,245,1,115,2,85,6,110,35,63,17,127,2,218,154,63,234,170,187,245,170,162],
        },
        {
            function: "KEY_2",
            name: "KEY_2",
            icon: "KEY_2",
            command: [68,0,4,115,2,245,1,115,2,85,6,110,35,63,17,127,2,218,154,63,234,170,173,253,170,162],
        },
        {
            function: "KEY_3",
            name: "KEY_3",
            icon: "KEY_3",
            command: [68,0,4,115,2,245,1,115,2,85,6,110,35,63,17,127,2,218,154,63,234,170,181,251,170,162],
        },
        {
            function: "KEY_4",
            name: "KEY_4",
            icon: "KEY_4",
            command: [68,0,4,115,2,245,1,115,2,85,6,110,35,63,17,127,2,218,154,63,234,170,189,245,106,162],
        },
        {
            function: "KEY_5",
            name: "KEY_5",
            icon: "KEY_5",
            command: [68,0,4,115,2,245,1,115,2,85,6,110,35,63,17,127,2,218,154,63,234,170,174,253,106,162],
        },
        {
            function: "KEY_6",
            name: "KEY_6",
            icon: "KEY_6",
            command: [68,0,4,115,2,245,1,115,2,85,6,110,35,63,17,127,2,218,154,63,234,170,182,251,106,162],
        },
        {
            function: "KEY_7",
            name: "KEY_7",
            icon: "KEY_7",
            command: [68,0,4,115,2,245,1,115,2,85,6,110,35,63,17,127,2,218,154,63,234,170,186,250,234,162],
        },
        {
            function: "KEY_8",
            name: "KEY_8",
            icon: "KEY_8",
            command: [68,0,4,115,2,245,1,115,2,85,6,110,35,63,17,127,2,218,154,63,234,170,173,126,234,162],
        },
        {
            function: "KEY_9",
            name: "KEY_9",
            icon: "KEY_9",
            command: [68,0,4,115,2,245,1,115,2,85,6,110,35,63,17,127,2,218,154,63,234,170,181,125,234,162],
        },
        {
            function: "KEY_0",
            name: "KEY_0",
            icon: "KEY_0",
            command: [68,0,4,115,2,245,1,115,2,85,6,110,35,63,17,127,2,218,154,63,234,170,175,125,90,162],
        },
        {
            function: "KEY_FAVORITES",
            name: "KEY_FAVORITES",
            icon: "KEY_FAVORITES",
            command: [68,0,4,115,2,245,1,115,2,85,6,110,35,63,17,127,2,218,154,63,234,170,181,87,126,162],
        },
        {
            function: "KEY_LAST",
            name: "KEY_LAST",
            icon: "KEY_LAST",
            command: [68,0,4,115,2,245,1,115,2,85,6,110,35,63,17,127,2,218,154,63,234,170,171,191,90,162],
        },
        {
            function: "KEY_VOLUMEUP",
            name: "KEY_VOLUMEUP",
            icon: "KEY_VOLUMEUP",
            command: [68,0,4,115,2,245,1,115,2,85,6,110,35,63,17,127,2,218,154,63,234,170,170,255,170,162],
        },
        {
            function: "KEY_VOLUMEDOWN",
            name: "KEY_VOLUMEDOWN",
            icon: "KEY_VOLUMEDOWN",
            command: [68,0,4,115,2,245,1,115,2,85,6,110,35,63,17,127,2,218,154,63,234,170,171,127,106,162],
        },
        {
            function: "KEY_CHANNELUP",
            name: "KEY_CHANNELUP",
            icon: "KEY_CHANNELUP",
            command: [68,0,4,115,2,245,1,115,2,85,6,110,35,63,17,127,2,218,154,63,234,170,173,222,214,162],
        },
        {
            function: "KEY_CHANNELDOWN",
            name: "KEY_CHANNELDOWN",
            icon: "KEY_CHANNELDOWN",
            command: [68,0,4,115,2,245,1,115,2,85,6,110,35,63,17,127,2,218,154,63,234,170,173,175,110,162],
        },
        {
            function: "KEY_MUTE",
            name: "KEY_MUTE",
            icon: "KEY_MUTE",
            command: [68,0,4,115,2,245,1,115,2,85,6,110,35,63,17,127,2,218,154,63,234,170,170,191,234,162],
        },
        {
            // function: "Tv/radio",
            function: "KEY_SOURCE",
            name: "KEY_SOURCE",
            icon: "KEY_SOURCE",
            command: [68,0,4,115,2,245,1,115,2,85,6,110,35,63,17,127,2,218,154,63,234,170,174,175,94,162],
        },
        {
            function: "KEY_MENU",
            name: "KEY_MENU",
            icon: "KEY_MENU",
            command: [68,0,4,115,2,245,1,115,2,85,6,110,35,63,17,127,2,218,154,63,234,170,182,189,186,162],
        },
        {
            function: "KEY_EXIT",
            name: "KEY_EXIT",
            icon: "KEY_EXIT",
            command: [68,0,4,115,2,245,1,115,2,85,6,110,35,63,17,127,2,218,154,63,234,170,173,111,118,162],
        },
        {
            function: "KEY_UP",
            name: "KEY_UP",
            icon: "KEY_UP",
            command: [68,0,4,115,2,245,1,115,2,85,6,110,35,63,17,127,2,218,154,63,234,170,191,90,171,162],
        },
        {
            function: "KEY_DOWN",
            name: "KEY_DOWN",
            icon: "KEY_DOWN",
            command: [68,0,4,115,2,245,1,115,2,85,6,110,35,63,17,127,2,218,154,63,234,170,175,174,171,162],
        },
        {
            function: "KEY_LEFT",
            name: "KEY_LEFT",
            icon: "KEY_LEFT",
            command: [68,0,4,115,2,245,1,115,2,85,6,110,35,63,17,127,2,218,154,63,234,170,173,215,107,162],
        },
        {
            function: "KEY_RIGHT",
            name: "KEY_RIGHT",
            icon: "KEY_RIGHT",
            command: [68,0,4,115,2,245,1,115,2,85,6,110,35,63,17,127,2,218,154,63,234,170,183,173,171,162],
        },
        {
            function: "KEY_OK",
            name: "KEY_OK",
            icon: "KEY_OK",
            command: [68,0,4,115,2,245,1,115,2,85,6,110,35,63,17,127,2,218,154,63,234,170,189,173,91,162],
        },
        {
            function: "KEY_GREEN",
            name: "KEY_GREEN",
            icon: "KEY_GREEN",
            command: [68,0,4,115,2,245,1,115,2,85,6,110,35,63,17,127,2,218,154,63,234,170,187,122,218,162],
        },
        {
            function: "KEY_YELLOW",
            name: "KEY_YELLOW",
            icon: "KEY_YELLOW",
            command: [68,0,4,115,2,245,1,115,2,85,6,110,35,63,17,127,2,218,154,63,234,170,173,190,218,162],
        },
        {
            function: "KEY_BLUE",
            name: "KEY_BLUE",
            icon: "KEY_BLUE",
            command: [68,0,4,115,2,245,1,115,2,85,6,110,35,63,17,127,2,218,154,63,234,170,181,189,218,162],
        },
        {
            function: "KEY_RED",
            name: "KEY_RED",
            icon: "KEY_RED",
            command: [68,0,4,115,2,245,1,115,2,85,6,110,35,63,17,127,2,218,154,63,234,170,187,173,107,162],
        },
        {
            function: "KEY_EPG",
            name: "KEY_EPG",
            icon: "KEY_EPG",
            command: [68,0,4,115,2,245,1,115,2,85,6,110,35,63,17,127,2,218,154,63,234,170,170,187,245,162],
        },
        {
            function: "Timer",
            name: "Timer",
            icon: "Timer",
            command: [68,0,4,115,2,245,1,115,2,85,6,110,35,63,17,127,2,218,154,63,234,170,186,221,118,162],
        },
    ]
}
export default samsung_MF59_00242C